export default function hasResubmitPermissions(permissions, environment) {
  return permissions && permissions.orderManagement
    ? !!permissions.orderManagement.find(
        p =>
          (p.identifier === environment || p.identifier === '*') &&
          p.permissions.includes('resubmit:order')
      )
    : false;
}
